export default __webpack_public_path__ + "static/media/status-done.916421f0.svg";